import { PricingPlanInterval, PricingPlanSchema } from 'types';
import { displayPrice, mapPricingPlanInterval } from 'utils';

import Feature from './Feature';

import styles from './MembershipPlanCard.module.scss';

export type MembershipPlanCardProps = PricingPlanSchema & {
  channelName: string;
};

const displayPriceAndInterval = (price: number, interval: PricingPlanInterval) =>
  `$${displayPrice(price)} per ${mapPricingPlanInterval(interval)}`.toLocaleLowerCase();

const MembershipPlanCard = ({ price, interval, channelName }: MembershipPlanCardProps): JSX.Element => (
  <div className={styles.container}>
    <div className={styles.header}>
      <p className={styles.title}>Membership</p>
      <ul className={styles.price}>
        <li>
          <span>{displayPriceAndInterval(price * 100, interval)}</span>
        </li>
      </ul>
    </div>

    <ul className={styles.features}>
      <li>
        <Feature available>Get access to all “{channelName}” channel content</Feature>
      </li>
    </ul>
  </div>
);

export default MembershipPlanCard;
